import app from 'flarum/forum/app';
import {extend, override} from 'flarum/common/extend';
import Discussion from 'flarum/common/models/Discussion';
import Post from 'flarum/common/models/Post';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import WordpressSummaryPost from './components/WordpressSummaryPost';

export default function () {
    app.postComponents.kilowhatWordpressPostSummary = WordpressSummaryPost;

    // Make contentHtml and contentPlain work like normal comment posts, so that summaries can work with them
    override(Post.prototype, 'contentHtml', function (original: any) {
        if (this.contentType() === 'kilowhatWordpressPostSummary') {
            const content = this.content() as any;

            return content.body ? content.body : '';
        }

        return original();
    });

    extend(DiscussionListItem.prototype, 'infoItems', function (items) {
        if ((app.forum.attribute('kilowhatWordpressShowDiscussionThumbnail') as string[] || []).indexOf('list') === -1) {
            return;
        }

        const discussion = this.attrs.discussion as Discussion;
        const post = discussion.firstPost();

        if (!post) {
            return;
        }

        const content = post.content() as any;

        if (!content || !content.thumbnailUrl) {
            return;
        }

        items.add('kilowhat-wordpress-thumbnail', m('img.KilowhatWordpressDiscussionListItem-Thumbnail', {
            src: content.thumbnailUrl,
            alt: content.title || app.translator.trans('kilowhat-wordpress.forum.thumbnail_alt_fallback'),
        }));
    });
}
